import { useState } from "react";
import { useTranslation } from "react-i18next";
import { validateEmail } from "../../../utils/helper";
import PartnerFooter from "../../components/PartnerFooter";
import ScreenHeader from "../../components/ScreenHeader";
import "./addEmail.scss";

// V2 add-email page ("הוספת אימייל"), rendered under the /registration route and
// gated inside screens/registration.jsx. The V1 screen keeps owning the save
// (UpdateClientEmailByMobile), the login() refresh and the navigation — they arrive
// here as onSubmit. No back control: /registration is a forced gate reached by
// redirect from the handshake, so there is nowhere to go back to.
function AddEmail({ fullName, onSubmit }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  const greeting = fullName ? `${t("HEY")} ${fullName},` : `${t("HEY")},`;

  const handleChange = (e) => {
    setIsInvalid(false);
    setEmail(e.target.value);
  };

  const handleSubmit = () => {
    if (!validateEmail(email)) {
      setIsInvalid(true);
      return;
    }

    onSubmit(email);
  };

  return (
    <div className="ae-v2">
      <ScreenHeader title={t("ADD_EMAIL_TITLE")} variant="none" />

      <div className="ae-v2-content">
        <h1 className="ae-v2-title">{greeting}</h1>
        <p className="ae-v2-subtitle">{t("EMAIL_REQUIRED")}</p>

        <input
          type="email"
          inputMode="email"
          autoComplete="email"
          className={`ae-v2-input${isInvalid ? " ae-v2-input--invalid" : ""}`}
          placeholder={t("EMAIL_PLACEHOLDER")}
          value={email}
          onChange={handleChange}
        />
        {isInvalid && <p className="ae-v2-error">{t("EMAIL_INVALID")}</p>}

        <button type="button" className="ae-v2-cta" onClick={handleSubmit} disabled={!email}>
          {t("CONTINUE")}
        </button>
      </div>

      <PartnerFooter />
    </div>
  );
}

export default AddEmail;
